import { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import DigitalIdentity from "./Components/Dashboard/DigitalIdentity.js";
import DigitalIdentityPaid from "./Components/Dashboard/DigitalIdentityPaid.js";
import Header from "./Components/Dashboard/Header.js";
import HomePage from "./Components/Dashboard/HomePage.js";
import Sidebar from "./Components/Dashboard/Sidebar.js";
import Calendar from "./Components/Dashboard/Testing.js";

// Import components from Project "O"
import ParentActiveStep from "./Components/Onboarding/ParentActiveStep.js";
import PreOnboard from "./Components/Onboarding/PreOnboard.js";
// import UserProfile from "./Components/Onboarding/UserProfile";
import AllCards from "./Components/Dashboard/Cards/AllCards.js";
import CardDetailedView from "./Components/Dashboard/Cards/CardDetailedView.js";
import Cardedit from "./Components/Dashboard/Cards/CardEditTemplate.js";
// import UserDetailsNew from './Components/Dashboard/UserDetails2';
import CreateCard from "./Components/Dashboard/Cards/CardCreatePart/CreateCard.js";
import FavouriteCards from "./Components/Dashboard/Cards/FavouriteCards.js";
import UserDetails2 from "./Components/Dashboard/UserDetails2.js";
// import Myprofile from './Components/Dashboard/Myprofile/Myprofile'
import AllBusinessCard from "./Components/Dashboard/Cards/AllBusinessCard.js";
import FamilyDashboard from "./Components/Dashboard/Cards/GroupCard/FamilyDashboard.js";
import ParentGroupCard from "./Components/Dashboard/Cards/GroupCard/ParentGroupCard.js";
import CardView from "./Components/Dashboard/CardView.js";
import AllContactsGroup from "./Components/Dashboard/Contact/AllContactsGroup.js";
import Connect from "./Components/Dashboard/Contact/Connect.js";
import ContactFolderMembers from "./Components/Dashboard/Contact/ContactFolderMembers.js";
import ContactV1 from "./Components/Dashboard/Contact/Contacts.v1.js";
import AddAdminCreateGroup from "./Components/Dashboard/Contact/Groups/AddAdminCreateGroup.js";
import AddPeopleToGroup from "./Components/Dashboard/Contact/Groups/AddPeopleToGroup.js";
import ConnectedContacts from "./Components/Dashboard/Contact/Groups/ConnectedContacts.js";
import CreateGroup from "./Components/Dashboard/Contact/Groups/CreateGroup.js";
import EditGroupDetails from "./Components/Dashboard/Contact/Groups/EditGroupDetails.js";
import GroupDetailedView from "./Components/Dashboard/Contact/Groups/GroupDetailedView.js";
import AllGroupDetails from "./Components/Dashboard/Contact/SubPages_Contacts/AllGroupDetails.js";
import CardConnectedMembers from "./Components/Dashboard/Contact/SubPages_Contacts/CardConnectedMembers.js";
import FavouriteContacts from "./Components/Dashboard/Contact/SubPages_Contacts/FavouriteContacts.js";
import UnVerifiedContacts from "./Components/Dashboard/Contact/SubPages_Contacts/UnVerifiedContacts.js";
import UserConnectFullView from "./Components/Dashboard/Contact/SubPages_Contacts/UserConnectFullView.js";
import Folders from "./Components/Dashboard/Folders.js";
import ParentHomePage from "./Components/Dashboard/HomePage/ParentHomePage.js";
import CountrySelecting from "./Components/Dashboard/KYC/CountrySelecting.js";
import VerifyAadhar from "./Components/Dashboard/KYC/VerifyAadhar.js";
import VerifyBirthday from "./Components/Dashboard/KYC/Verifybirth.js";
import VerifyDocs from "./Components/Dashboard/KYC/VerifyDocs.js";
import Verifydrivinglicense from "./Components/Dashboard/KYC/Verifydrivinglicense.js";
import VerifyEPF from "./Components/Dashboard/KYC/VerifyEPF.js";
import VerifyNric from "./Components/Dashboard/KYC/VerifyNric.js";
import VerifyNricForm from "./Components/Dashboard/KYC/VerifyNricForm.js";
import Verifypancard from "./Components/Dashboard/KYC/Verifypancard.js";
import VerifyPassport from "./Components/Dashboard/KYC/VerifyPassport.js";
import Verifyresidentialaddress from "./Components/Dashboard/KYC/Verifyresidentialaddress.js";
import VerifyResidentialForm from "./Components/Dashboard/KYC/VerifyResidentialForm.js";
import VerifyVisa from "./Components/Dashboard/KYC/VerifyVisa.js";
import ApplicantSinglePage from "./Components/Dashboard/MyProfileDetails/ApplicantSinglePage.js";
import ApplicantsPage from "./Components/Dashboard/MyProfileDetails/ApplicantsPage.js";
import CandidateSinglePage from "./Components/Dashboard/MyProfileDetails/CandidateSinglePage.js";
import JobDescriptionSidebar from "./Components/Dashboard/MyProfileDetails/JobDescriptionSidebar.js";
import ParentProfile from "./Components/Dashboard/MyProfileDetails/ParentProfile.js";
import Portfolio from "./Components/Dashboard/MyProfileDetails/ProfessionalProfileComponents/Portfolio.js";
import ResumeGenerate from "./Components/Dashboard/MyProfileDetails/ProfessionalProfileComponents/ResumeGenerate.js";
import VideoResume from "./Components/Dashboard/MyProfileDetails/ProfessionalProfileComponents/VideoResume.js";
import RecruiterDashBoard from "./Components/Dashboard/MyProfileDetails/RecruiterDashBoard.js";
import AllJobs from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/AllJobs.js";
import CandidateProgress from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/CandidateProgress.js";
import FavouriteJobs from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/FavouriteJobs.js";
import GlobalCandidates from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/GlobalCandidates.js";
import OtherJobs from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/OtherJobs.js";
import ViewRecruiterOfferLetter from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/ViewRecruiterOfferLetter.js";
import VerificationProfile from "./Components/Dashboard/MyProfileDetails/Verification.external.js";
import Notes from "./Components/Dashboard/Notes.js";
import ID from "./Components/Dashboard/PrivateId/ID.js";
import ProfileViewParent from "./Components/Dashboard/ProfileOtherUserView/ParentProfile.js";
import RecommendationSubmission from "./Components/Dashboard/Recommendation.js";
import UserDetailGlobalSearch from "./Components/Dashboard/SubPages/UserDetailGlobalSearch.js";
import UserAccountDelete from "./Components/Dashboard/User/UserAccountDelete.js";
import VerificationFile from "./Components/Dashboard/VerificationFile.js";
import Virtual from "./Components/Dashboard/VirtualBackground/Virtual.js";
import Login from "./Components/Onboarding/Login.js";
import SessionHandler from "./Components/SessionManagement/SessionHandler.js";
import WebsiteUrl from "./Components/WebsiteUrl.js";
// import Dashboard from "./Components/Dashboard/Admindashboard.js/Dashboard.js";
import AllCandidatesInfo from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/AllCandidatesInfo.js";
import AppliedSaveJob from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/AppliedSaveJob.js";
import ViewApplicantOfferLetter from "./Components/Dashboard/MyProfileDetails/ViewApplicantOfferLetter.js";
// import EventSinglePage from "./Community/EventSinglePage.js";
import { useDispatch, useSelector } from "react-redux";
// import EditEventSinglePage from "./Community/EditEventSinglePage.js";
// import OnlyCommunitySinglePage from "./Community/OnlyCommunitySinglePage.js";
import AppChat from "Components/Dashboard/CCEF/client/pages/AppChat";
import Call from "Components/Dashboard/CCEF/client/pages/Call";
import VoiceCall from "Components/Dashboard/CCEF/client/pages/VoiceCall";

import BlogsSinglePage from "./Components/Dashboard/Community/Blogs/BlogsSinglePage.js";
import CommunityMainScreen from "./Components/Dashboard/Community/CommunityDashboard/CommunityMainScreen.js";
import CommunityProfileScreen from "./Components/Dashboard/Community/CommunityDashboard/CommunityProfileScreen.js";
import AccessLogMainscreen from "./Components/Dashboard/Community/Events/AccessLogMainscreen";
import EventDashboardPage from "./Components/Dashboard/Community/Events/EventDashboardPage";
import EventSinglePage from "./Components/Dashboard/Community/Events/EventSinglePage.js";
import VolunteerDetailMainScreen from "./Components/Dashboard/Community/Events/VolunteerDetailMainScreen";
import FeedSinglePage from "./Components/Dashboard/Community/Feeds/FeedSinglePage.js";
// import AgoraVideoCall from "./Components/Dashboard/Contact/AgoraVideoCall.js";
import IncomingCallScreen from "./Components/Dashboard/Contact/IncomingCallScreen.js";
import ParentDiscount from "./Components/Dashboard/Discount/ParentDiscount.js";
import EducationAndCertificate from "./Components/Dashboard/HomePage/Neoin_Education/EducationAndCertificate.js";
import PersonalityDetails from "./Components/Dashboard/HomePage/PersonalityTest/PersonalityDetails.js";
import PersonalitySaboteur from "./Components/Dashboard/HomePage/PersonalityTest/PersonalitySaboteur.js";
import PersonalityTest from "./Components/Dashboard/HomePage/PersonalityTest/PersonalityTest.js";
import SingleJobDescription from "./Components/Dashboard/MyProfileDetails/SideFeedComponents/SingleJobDescription.js";
import PublicRoute from "./Components/SessionManagement/PublicRoute";
import PersonalEvents from "./Components/Dashboard/Community/Events/PersonalEvents";
import ComingSoonPage from "./Components/ComingSoonPage";
import { useUserDetailContext } from "./Components/UserDetailContext.js";
import ProfessionalEvents from "./Components/Dashboard/Community/Events/ProfessionalEvents";
import VolunteersPage from "./Components/Dashboard/Community/Events/VolunteerPage";
import ComposeLetterPage from "./Components/Dashboard/letterhead/ComposeLetterPage";
import ExternalSignPage from "./Components/Dashboard/letterhead/ExternalSignPage";
import ProductMarketplace from "./Components/GlobalProducts/ProductMarketplace";
import ProductSinglePage from "./Components/GlobalProducts/ProductSinglePage";
import AnalyticsDashboard from "Components/Dashboard/MyProfileDetails/SideFeedComponents/AnalyticsDashboard";
import PublicDocview from "./Components/Dashboard/PrivateId/PublicDocview";
import DocumentUpload from "./Components/Dashboard/Documents/DocumentUpload";
import LetterheadMainPage from "./Components/Dashboard/letterhead/LetterheadMainPage";
import CreateTemplatePage from "./Components/Dashboard/letterhead/CreateTemplatePage";
import AuditLogsPage from "./Components/Dashboard/letterhead/AuditLogsPage";
import ParentActiveStep2 from "./Components/Onboarding/ParentActiveStep2";
// import CreateTemplatePage from "./Components/Dashboard/letterhead/CreateTemplatePage";
// import CreateTemplatePage from "./Components/Dashboard/letterhead/CreateTemplatePage";

const MainContent = ({
  setIsLightBoxVisible,
  isVideoCallActive,
  callData,
  setIsVideoCallActive,
  onStartVideoCall,
  setCallData,
}) => {
  // console.log("setCallData5252", callData);
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useUserDetailContext();
  const query = useQuery();
  // console.log("query15915", location.pathname)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);
  const isUserLoggedin = localStorage.getItem("objectId");

  // Check if the URL matches the pattern '/digital-identity/:id'
  const isDigitalIdentityScreen =
    location.pathname.startsWith("/digital-identity/");
  const verification =
    location.pathname.startsWith("/verification/") ||
    location.pathname.startsWith("/verification-profile/");
  const isViewScreen = location.pathname.startsWith("/view-card");
  const recommend = location.pathname.startsWith("/recommend");
  const signDocument = location.pathname.startsWith("/sign-document");
  // const isEnterprisePort = window.location.port === '4000';
  // const shouldHideNavigation = isEnterprisePort;
  // const isEnterprise = window.location.port === '4000';

  // const queryParams = new URLSearchParams(window.location.search);
  // const isEmbedded = queryParams.get('embed') === 'true';

  // // Hide navigation if on Enterprise OR embedded mode
  // const hideNavigation = isEnterprise || isEmbedded;

  // console.log("Port:", window.location.port, "| Hide Nav:", hideNavigation);

  // console.log("Current Port:", window.location.port);
  // console.log("Hide Navigation:", shouldHideNavigation);
  const isPortfolioScreen =
    location.pathname.startsWith("/portfolio") ||
    location.pathname === "/static-portfolio";
  const isDeleteAccountScreen = location.pathname.startsWith("/delete-account");
  // Check if the URL matches the pattern '/'
  const isHome = location.pathname === "/";
  const isWelcome = location.pathname === "/welcome";

  // Check if the URL matches the pattern '/signup'
  const isSignup = location.pathname.startsWith("/signup");
  const isJDSignup = location.pathname.startsWith("/jd-signup");
  const isLogin = location.pathname.startsWith("/login");
  const isEventSinglePage = location.pathname.startsWith("/explore/events/");
  const isSingleJobPage = location.pathname.startsWith("/job-description/");
  const isinVideoCall = location.pathname.startsWith("/video-call");
  const [incomingCall, setIncomingCall] = useState(null);
  const isScanedDoc =location.pathname.startsWith("/public-docview");
  const dispatch = useDispatch();
  const getCallInvitation = useSelector((state) => state.jobs.getCallInvitation);
  useEffect(() => {
    if (
      getCallInvitation &&
      getCallInvitation.length > 0 &&
      !isVideoCallActive &&
      !incomingCall
    ) {
      const now = new Date();

      // Find the most recent unhandled call within last 30 seconds
      const recentCall = getCallInvitation.find((call) => {
        const callTime = new Date(call.created_at);
        const timeDiff = (now - callTime) / 1000;
        return timeDiff <= 30 && !call.handled;
      });

      // console.log("I am Recent call", recentCall)

      if (recentCall && recentCall.owner_id !== userDetails?.reference_id) {
        // Don't show incoming call if it's from yourself
        setIncomingCall({
          callId: recentCall.id,
          caller: {
            ...recentCall.owner,
            name: `${recentCall.owner.first_name} ${recentCall.owner.last_name}`,
            img: recentCall.owner.profile_url,
            id: recentCall.owner_id,
            contact_ref_id: recentCall.owner_id,
          },
          meetingName: recentCall.meet_name,
          rtcToken: recentCall.rtc_token,
          uid: recentCall.recipient_id,
        });
      }
    }
  }, [getCallInvitation, isVideoCallActive, incomingCall, userDetails]);

  // useEffect(() => {
  //   const initRTM = async () => {
  //     const userId =
  //       userDetails?.contactrefid ??
  //       userDetails?.contact_ref_id ??
  //       userDetails?.reference_id;

  //     if (!userId) {
  //       console.log("⏳ Waiting for user details to initialize RTM");
  //       return;
  //     }

  //     try {
  //       // console.log("🚀 Initializing RTM for user:", userId);

  //       // Try to get RTM token from backend (optional - can work without)
  //       let rtmToken = null;
  //       try {
  //         rtmToken = await fetchRTMToken(userId);
  //         console.log("✅ RTM token fetched");
  //       } catch (error) {
  //         console.warn("⚠️ RTM token fetch failed, proceeding without token");
  //       }

  //       // Initialize RTM client
  //       await initializeRTM(userId, rtmToken);
  //       console.log("✅ RTM initialized successfully");
  //     } catch (error) {
  //       console.error("❌ RTM initialization failed:", error);
  //     }
  //   };

  //   initRTM();
  // }, [userDetails]);

  // useEffect(() => {
  //   const handleIncomingCall = (event) => {
  //     // console.log("event is coming", event, event?.detail);
  //     // const { caller, meetingName, rtcToken, uid, to } = event.detail;
  //     // Only show if current user is invited
  //     // if (currentUserId === to) {
  //     //   setIncomingCall({ caller, meetingName, rtcToken, uid });
  //     // }
  //   };

  //   window.addEventListener("incoming-call", handleIncomingCall);
  //   return () =>
  //     window.removeEventListener("incoming-call", handleIncomingCall);
  // }, []);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Handle sidebar item click testing
  const handleItemClick = (componentName) => {
    setActiveComponent(componentName);
  };

  // Set active component
  const setActive = (component) => {
    setActiveComponent(component);
  };

  // Define components mapping
  const componentsMap = {
    DigitalIdentity: DigitalIdentity,
    Calendar: Calendar,
    Home: HomePage,
  };

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  // useEffect(() => {
  //   const path = location.pathname;

  //   // Only set video call active if we navigate to /video-call AND we have callData
  //   if (path === "/video-call" && !isVideoCallActive && callData) {
  //     console.log("📍 Setting video call active from route");
  //     setIsVideoCallActive(true);
  //   }

  //   // Only deactivate if we navigate away from /video-call manually
  //   if (path !== "/video-call" && isVideoCallActive && !callData) {
  //     console.log("📍 Deactivating video call from route");
  //     setIsVideoCallActive(false);
  //   }
  // }, [location.pathname, isVideoCallActive, setIsVideoCallActive, callData]);

  // // ✅ KEEP this useEffect as is:
  // useEffect(() => {
  //   if (isVideoCallActive && location.pathname !== "/video-call") {
  //     navigate("/video-call");
  //   }
  // }, [isVideoCallActive, navigate, location.pathname]);

  return (
    <div
      className={`app ${isSidebarOpen &&
        !isDigitalIdentityScreen &&
        !recommend &&
        !isWelcome &&
        !verification &&
        // !isHome &&
        !isSignup &&
        !isJDSignup &&
        !isPortfolioScreen &&
        !isScanedDoc &&
        !isinVideoCall
        ? "sidebar-open"
        : "sidebar-closed"
        }`}
    >
      {incomingCall && !isVideoCallActive && (
        <IncomingCallScreen
          caller={incomingCall.caller}
          meetingName={incomingCall.meetingName}
          rtcToken={incomingCall.rtcToken}
          uid={incomingCall.uid}
          onAccept={async () => {
            try {
              console.log("✅ Accepting call with data:", incomingCall);

              // Mark call as handled in Redux
              // const updatedCalls = getCallInvitation.map((call) =>
              //   call.id === incomingCall.callId
              //     ? { ...call, handled: true }
              //     : call
              // );
              // dispatch({
              //   type: "UPDATE_CALL_INVITATIONS",
              //   payload: updatedCalls,
              // });

              // const rtcTokenResult = await fetchRTCToken(
              //   incomingCall.meetingName,
              //   incomingCall.recipient_id
              // );
              // const rtcToken =
              //   typeof rtcTokenResult === "string"
              //     ? rtcTokenResult
              //     : rtcTokenResult?.rtcToken ?? rtcTokenResult?.token ?? null;

              // Important: Build complete call configuration
              const callDataToUse = {
                meetingName: incomingCall.meetingName,
                // rtcToken: rtcToken,
                uid: incomingCall.recipient_id, // Use the assigned UID for this participant
                channelName: incomingCall.meetingName, // Must match the caller's channel
                participants: [incomingCall.caller.id], // Include caller's ID
                role: "participant", // Specify role as participant
                autoJoin: true, // Auto join the call
                initialAudioEnabled: true, // Enable audio by default
                initialVideoEnabled: true, // Enable video by default
              };
              const callDetails = {
                meetingName: incomingCall.meetingName,
                // rtcToken: rtcToken,
                uid: incomingCall.recipient_id,
                participants: [incomingCall.caller.id],
              };
              console.log(
                "📞 Starting video call with config:",
                callDataToUse,
                callDetails
              );

              // Clear incoming call state BEFORE starting call
              setIncomingCall(null);

              // Set video call active and pass complete call data
              setIsVideoCallActive(true);
              setCallData(callDetails); // Make sure this state is passed to 
              onStartVideoCall(callDataToUse);

              // Navigate to video call route
              navigate("/video-call");
            } catch (error) {
              console.error("❌ Error accepting call:", error);
              setIncomingCall(null);
            }
          }}
          onDecline={() => {
            console.log("❌ Declining call");

            // Mark call as handled in Redux
            const updatedCalls = getCallInvitation.map((call) =>
              call.id === incomingCall.callId
                ? { ...call, handled: true }
                : call
            );

            dispatch({
              type: "UPDATE_CALL_INVITATIONS",
              payload: updatedCalls,
            });

            setIncomingCall(null);
          }}
        />
      )}

      {/* {location.pathname === "/video-call" ? (
        <AgoraVideoCall
          meetingName={callData?.meetingName || "Meeting"}
          participants={callData?.participants || []}
          rtcToken={callData?.rtcToken}
          uid={callData?.uid}
          onEndCall={() => setIsVideoCallActive(false)}
          userId={userDetails?.reference_id}
        />
      ) : ( */}
      <>
        {!isDigitalIdentityScreen &&
          !verification &&
          !isViewScreen &&
          !recommend &&
          // !isHome &&
          !isWelcome &&
          !isSignup &&
          !isJDSignup &&
          !isLogin &&
          !isPortfolioScreen &&
          !signDocument &&
          !isScanedDoc &&
          (!isEventSinglePage || isUserLoggedin) &&
          (!isSingleJobPage || isUserLoggedin) &&
          (isUserLoggedin || !isDeleteAccountScreen) ? (
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            setActive={setActive}
            handleItemClick={handleItemClick}
          />
        ) : (
          <> </>
        )}

        <div className="main-content">
          {/* Render header if it's not the digital identity, home, signup, or portfolio screen */}
          {!isDigitalIdentityScreen &&
            !verification &&
            !isViewScreen &&
            !recommend &&
            // !isHome &&
            !isWelcome &&
            !isSignup &&
            !isJDSignup &&
            !isLogin &&
            !isPortfolioScreen &&
            !signDocument &&
            !isScanedDoc &&
            (!isEventSinglePage || isUserLoggedin) &&
            (!isSingleJobPage || isUserLoggedin) &&
            (isUserLoggedin || !isDeleteAccountScreen) ? (
            <Header
              toggleSidebar={toggleSidebar}
              activeComponent={activeComponent}
              setIsLightBoxVisible={setIsLightBoxVisible}
            />
          ) : (
            <> </>
          )}

          {/* Render the main content */}
          <Routes>
            <Route
              path="/"
              element={
                <SessionHandler>
                  <ParentHomePage />
                </SessionHandler>
              }
            />
            <Route path="/signup" element={<PublicRoute><ParentActiveStep /></PublicRoute>} />
            <Route path="/jd-signup" element={<PublicRoute><ParentActiveStep2 /></PublicRoute>} />
            <Route path="/welcome" element={<PublicRoute><PreOnboard /></PublicRoute>} />
            <Route path="/coming-soon" element={<ComingSoonPage />} />
            {isDigitalIdentityScreen && (
              <Route
                path="/digital-identity/:card/:id"
                element={<UserDetails2 />}
              />
            )}
            {verification && (
              <Route
                path="/verification/response"
                element={
                  <VerificationFile
                    token={query.get("token")}
                    action={query.get("action")}
                    requestId={query.get("requestId")}
                  />
                }
              />
            )}
            {verification && (
              <Route
                path="/verification-profile/response"
                element={
                  <VerificationProfile
                    token={query.get("token")}
                    action={query.get("action")}
                    requestId={query.get("requestId")}
                    section={query.get("section")}
                  />
                }
              />
            )}
            {isViewScreen && (
              <Route path="/view-card/:card/:id" element={<CardView />} />
            )}
            {recommend && (
              <Route
                path="/recommend"
                element={<RecommendationSubmission />}
              />
            )}
            <Route
              path="/home"
              element={
                <SessionHandler>
                  <ParentHomePage />
                </SessionHandler>
              }
            />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route
              path="/digital-identity"
              element={
                <SessionHandler>
                  <DigitalIdentity />
                </SessionHandler>
              }
            />
            <Route
              path="/digital-identity-paid"
              element={
                <SessionHandler>
                  <DigitalIdentityPaid />
                </SessionHandler>
              }
            />
            <Route path="/calendar" element={<Calendar />} />
            <Route
              path="/cards"
              element={
                <SessionHandler>
                  <AllCards />
                </SessionHandler>
              }
            />
            <Route
              path="/AllBusinessCard"
              element={
                <SessionHandler>
                  <AllBusinessCard />
                </SessionHandler>
              }
            />
            <Route
              path="/familyCard/:id"
              element={
                <SessionHandler>
                  <ParentGroupCard />
                </SessionHandler>
              }
            />
            <Route
              path="/edit-card"
              element={
                <SessionHandler>
                  <Cardedit isSidebarOpen={isSidebarOpen} />
                </SessionHandler>
              }
            />
            <Route
              path="/create-card"
              element={
                <SessionHandler>
                  <CreateCard isSidebarOpen={isSidebarOpen} />
                </SessionHandler>
              }
            />
            {/* Add route for CardDetailedView */}
            <Route
              path="/card/:id"
              element={
                <SessionHandler>
                  <CardDetailedView />
                </SessionHandler>
              }
            />
            <Route
              path="/Favourites"
              element={
                <SessionHandler>
                  <FavouriteCards />
                </SessionHandler>
              }
            />
            {/* <Route path="/profile" element={<Myprofile />} /> */}
            <Route
              path="/myprofile"
              element={
                <SessionHandler>
                  <ParentProfile />
                </SessionHandler>
              }
            >
              <Route
                path="create-video-resume"
                element={
                  <SessionHandler>
                    <VideoResume />
                  </SessionHandler>
                }
              />
              <Route
                path="generate-resume"
                element={
                  <SessionHandler>
                    <ResumeGenerate />
                  </SessionHandler>
                }
              />
              {/* Fallback to handle undefined paths */}
              <Route
                path="*"
                element={<Navigate to="/myprofile" replace />}
              />
            </Route>
            <Route
              path="/portfolio"
              element={
                // <SessionHandler>
                <Portfolio />
                // </SessionHandler>
              }
            />
            {/* ...other routes... */}
            <Route
              path="/recruitment-Status"
              element={
                <SessionHandler>
                  <RecruiterDashBoard />
                </SessionHandler>
              }
            />
            <Route
              path="/analytics-dashboard"
              element={
                <SessionHandler>
                  <AnalyticsDashboard />
                </SessionHandler>
              }
            />

            <Route
              path="/all-candidatesinfo"
              element={
                <SessionHandler>
                  <AllCandidatesInfo />
                </SessionHandler>
              }
            />
            <Route
              path="/candidateSingle-page/:id"
              element={
                <SessionHandler>
                  {/* <RecruitmentStatus /> */}

                  <CandidateSinglePage />
                </SessionHandler>
              }
            ></Route>
            <Route
              path="/alljobs"
              element={
                <SessionHandler>
                  <AllJobs />
                </SessionHandler>
              }
            />
            <Route
              path="/jobopening"
              element={
                <SessionHandler>
                  <OtherJobs />
                </SessionHandler>
              }
            />
            <Route
              path="/applicant"
              element={
                <SessionHandler>
                  <ApplicantsPage />
                </SessionHandler>
              }
            />
            <Route
              path="/applicant-page/:id"
              element={
                <SessionHandler>
                  <ApplicantSinglePage />
                </SessionHandler>
              }
            />
            <Route
              path="/job-description/:id"
              element={
                // <SessionHandler>
                <SingleJobDescription />
                // </SessionHandler>
              }
            />
            <Route
              path="/job-description-sidebar/:id"
              element={
                <SessionHandler>
                  <JobDescriptionSidebar />
                </SessionHandler>
              }
            />
            <Route
              path="/favourite-jobs"
              element={
                <SessionHandler>
                  <FavouriteJobs />
                </SessionHandler>
              }
            />
            <Route
              path="/applicant-saved-jobs"
              element={
                <SessionHandler>
                  <AppliedSaveJob />
                </SessionHandler>
              }
            />
            <Route
              path="/candidate-progress"
              element={
                <SessionHandler>
                  <CandidateProgress />
                </SessionHandler>
              }
            />
            <Route
              path="/global-search"
              element={
                <SessionHandler>
                  <GlobalCandidates />
                </SessionHandler>
              }
            />
            v{" "}
            <Route
              path="/view-recruiter-offer-letter/:id"
              element={
                <SessionHandler>
                  <ViewRecruiterOfferLetter />
                </SessionHandler>
              }
            />
            <Route
              path="/view-applicant-offer-letter/:id"
              element={
                <SessionHandler>
                  <ViewApplicantOfferLetter />
                </SessionHandler>
              }
            />
            {/* <Route
              path="/letterheads"
              element={
                <SessionHandler>
                  <LetterheadMainPage/>
                </SessionHandler>
              }
            /> */}
            <Route
              path="/letterheads/:id"
              element={
                <SessionHandler>
                  {/* <ComposeLetterPage /> */}
                  <CreateTemplatePage/>
                </SessionHandler>
              }
            />
            <Route
              path="/create-template"
              element={
                <SessionHandler>
                  {/* <ComposeLetterPage /> */}
                  <CreateTemplatePage/>
                  {/* <LetterheadMainPage/> */}
                </SessionHandler>
              }
            />
            <Route
              path="/compose-letter"
              element={
                <SessionHandler>
                  <ComposeLetterPage />
                  {/* <CreateTemplatePage/> */}
                  {/* <LetterheadMainPage/> */}
                </SessionHandler>
              }
            />
            <Route
              path="/compose-letter/:id"
              element={
                <SessionHandler>
                  <ComposeLetterPage />
                  {/* <CreateTemplatePage/> */}
                  {/* <LetterheadMainPage/> */}
                </SessionHandler>
              }
            />
            <Route
              path="/audit-logs"
              element={
                <SessionHandler>
                 
                <AuditLogsPage/>
                </SessionHandler>
              }
            />
            <Route path="/sign-document" element={<ExternalSignPage />} />
            <Route path="/website-url" element={<WebsiteUrl />} />
            {/* contacts Pages */}
            <Route
              path="/contacts"
              element={
                <SessionHandler>
                  <ContactV1 onStartVideoCall={onStartVideoCall} />
                </SessionHandler>
              }
            />
            <Route
              path="/contacts/folder/:id"
              element={
                <SessionHandler>
                  <ContactFolderMembers />
                </SessionHandler>
              }
            />
            {/* <Route
                path="/one-to-one"
                element={
                  <SessionHandler>
                    <OneToOneChat/>
                  </SessionHandler>
                }
              /> */}
            {/* <Route
                path="/chats"
                element={
                  <SessionHandler>
                    <Chat/>
                  </SessionHandler>
                }
              /> */}
            <Route
              path="/connect-chat"
              element={
                <SessionHandler>
                  {/* <ChatCompo/>
                     */}
                  <AppChat setIsSidebarOpen={setIsSidebarOpen} />
                </SessionHandler>
              }
            />
            <Route
              path="/Call"
              element={
                <SessionHandler>
                  <Call />
                </SessionHandler>
              }
            />
            <Route
              path="/voice"
              element={
                <SessionHandler>
                  <VoiceCall />
                </SessionHandler>
              }
            />

            <Route
              path="/AllContacts_groups"
              element={
                <SessionHandler>
                  <AllContactsGroup />
                </SessionHandler>
              }
            />
            <Route
              path="/connect"
              element={
                <SessionHandler>
                  <Connect />
                </SessionHandler>
              }
            />
            <Route
              path="/userDetailedInfo"
              element={
                <SessionHandler>
                  <UserConnectFullView />
                </SessionHandler>
              }
            />
            <Route
              path="/create_group"
              element={
                <SessionHandler>
                  <CreateGroup />
                </SessionHandler>
              }
            />
            <Route
              path="/edit_group"
              element={
                <SessionHandler>
                  <EditGroupDetails />
                </SessionHandler>
              }
            />
            <Route
              path="/addPeopletoGroup"
              element={
                <SessionHandler>
                  <AddPeopleToGroup />
                </SessionHandler>
              }
            />
            <Route
              path="/connectedContacts"
              element={
                <SessionHandler>
                  <ConnectedContacts />
                </SessionHandler>
              }
            />
            <Route
              path="/groupContacts/:groupid"
              element={
                <SessionHandler>
                  <GroupDetailedView />
                </SessionHandler>
              }
            />
            <Route
              path="/favourite_contacts"
              element={
                <SessionHandler>
                  <FavouriteContacts />
                </SessionHandler>
              }
            />
            <Route
              path="/Unverified_Contacts"
              element={
                <SessionHandler>
                  <UnVerifiedContacts />
                </SessionHandler>
              }
            />
            <Route
              path="/add_adminGroup"
              element={
                <SessionHandler>
                  <AddAdminCreateGroup />
                </SessionHandler>
              }
            />
            <Route
              path="/addadminEditGroup"
              element={
                <SessionHandler>
                  <AddAdminCreateGroup />
                </SessionHandler>
              }
            />
            <Route
              path="/AllGroup_details"
              element={
                <SessionHandler>
                  <AllGroupDetails />
                </SessionHandler>
              }
            />
            <Route
              path="/Card_ConnectedMember/:cardName"
              element={
                <SessionHandler>
                  <CardConnectedMembers />
                </SessionHandler>
              }
            />
            {/* Global Search Page */}
            <Route
              path="/AllCardsUser/:encryptedId"
              element={
                <SessionHandler>
                  <UserDetailGlobalSearch />
                </SessionHandler>
              }
            />
            <Route
              path="/VirtualBackground"
              element={
                <SessionHandler>
                  <Virtual />
                </SessionHandler>
              }
            />
            {/* Kyc routing page */}
            <Route
              path="/countrySelecting"
              element={
                <SessionHandler>
                  <CountrySelecting />
                </SessionHandler>
              }
            />
            <Route
              path="/documents"
              element={
                <SessionHandler>
                  {/* <CountrySelecting /> */}
                  <DocumentUpload/>
                </SessionHandler>
              }
            />
            <Route
              path="/verify-docs"
              element={
                <SessionHandler>
                  <VerifyDocs />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyAdhar"
              element={
                <SessionHandler>
                  <VerifyAadhar />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyEPF"
              element={
                <SessionHandler>
                  <VerifyEPF />
                </SessionHandler>
              }
            />
            <Route
              path="/verifypancard"
              element={
                <SessionHandler>
                  <Verifypancard />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyresidential"
              element={
                <SessionHandler>
                  <Verifyresidentialaddress />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyResidentialForm"
              element={
                <SessionHandler>
                  <VerifyResidentialForm />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyDL"
              element={
                <SessionHandler>
                  <Verifydrivinglicense />
                </SessionHandler>
              }
            />
            <Route
              path="/verifypassport"
              element={
                <SessionHandler>
                  <VerifyPassport />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyvisa"
              element={
                <SessionHandler>
                  <VerifyVisa />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyNric"
              element={
                <SessionHandler>
                  <VerifyNric />
                </SessionHandler>
              }
            />
            <Route
              path="/verifyNricForm"
              element={
                <SessionHandler>
                  <VerifyNricForm />
                </SessionHandler>
              }
            />
            <Route
              path="/verifybirthday"
              element={
                <SessionHandler>
                  <VerifyBirthday />
                </SessionHandler>
              }
            />
            <Route
              path="/id"
              element={
                <SessionHandler>
                  <ID />
                </SessionHandler>
              }
            />
            <Route
              path="/public-docview"
              element={
                <PublicDocview />
              }
            />
            <Route
              path="/AllCardsUser/:encryptedId"
              element={
                <SessionHandler>
                  <UserDetailGlobalSearch />
                </SessionHandler>
              }
            />
            <Route
              path="profile"
              element={
                <SessionHandler>
                  <ProfileViewParent />
                </SessionHandler>
              }
            />
            <Route
              path="notes"
              element={
                <SessionHandler>
                  <Folders />
                </SessionHandler>
              }
            />
            <Route
              path="/familydashboard"
              element={
                <SessionHandler>
                  <FamilyDashboard />
                </SessionHandler>
              }
            />
            <Route
              path="notes/:id"
              element={
                <SessionHandler>
                  <Notes />
                </SessionHandler>
              }
            />
            <Route path="/delete-account" element={<UserAccountDelete />} />
            <Route path="/discount" element={<ParentDiscount />} />
            <Route
              path="/community"
              element={
                <SessionHandler>
                  <CommunityMainScreen />
                </SessionHandler>
              }
            />
            <Route
              path="/community-dashboard/:id"
              element={
                <SessionHandler>
                  <EventDashboardPage />
                </SessionHandler>
              }
            />
            <Route
              path="/community-volunteer-dashboard"
              element={
                <SessionHandler>
                  <VolunteersPage />
                </SessionHandler>
              }
            />
            <Route
              path="/event/:eventId/volunteer/:volunteerId"
              element={
                <SessionHandler>
                  <VolunteerDetailMainScreen />
                </SessionHandler>
              }
            />
            <Route
              path="/access-logs"
              element={
                <SessionHandler>
                  <AccessLogMainscreen />
                </SessionHandler>
              }
            />
            <Route
              path="/my-feeds"
              element={
                <SessionHandler>
                  <CommunityProfileScreen />
                </SessionHandler>
              }
            />
            <Route
              path="/blog-description/:id"
              element={
                <SessionHandler>
                  <BlogsSinglePage />
                </SessionHandler>
              }
            />
            <Route
              path="/product-marketplace"
              element={
                <SessionHandler>
                  <ProductMarketplace />
                </SessionHandler>
              }
            />
            <Route
              path="/product-single-page"
              element={
                <SessionHandler>
                  <ProductSinglePage />
                </SessionHandler>
              }
            />
            <Route path="/explore/events/:id" element={<EventSinglePage />} />
            <Route path="/personal-events" element={<PersonalEvents />} />
            <Route path="/professional-events" element={<ProfessionalEvents />} />
            {/* <Route
                path="/edit-event-description/:id"
                element={
                  <SessionHandler>
                    <EditEventSinglePage />
                  </SessionHandler>
                }
              /> */}
            {/* <Route
                path="/community-description/:id"
                element={
                  <SessionHandler>
                    <OnlyCommunitySinglePage />
                  </SessionHandler>
                }
              /> */}
            <Route
              path="/explore/feeds/:id"
              element={
                <SessionHandler>
                  <FeedSinglePage />
                </SessionHandler>
              }
            />
            <Route
              path="/personalitytest"
              element={
                <SessionHandler>
                  <PersonalityTest />
                </SessionHandler>
              }
            />
            <Route
              path="/personalDetails"
              element={
                <SessionHandler>
                  <PersonalityDetails />
                </SessionHandler>
              }
            />
            <Route
              path="/personalitySaboteur"
              element={
                <SessionHandler>
                  <PersonalitySaboteur />
                </SessionHandler>
              }
            />
            <Route
              path="/learningandcertifiate"
              element={
                <SessionHandler>
                  <EducationAndCertificate />
                </SessionHandler>
              }
            />
            {/* <Route
                path="/video-call"
                element={
                  <AgoraVideoCall
                    meetingName={callData?.meetingName || "Meeting"}
                    participants={callData?.participants || []}
                    rtcToken={callData?.rtcToken}
                    uid={callData?.uid}
                    onEndCall={() => setIsVideoCallActive(false)}
                    userId={userDetails?.reference_id}
                  />
                }
              /> */}
          </Routes>
        </div>
      </>

    </div>
  );
};

export default MainContent;
